import { Request } from '../../httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '../../httpClient/serverApi/types/IGetItemsParams';
import { IGetItemsResult } from '../../httpClient/serverApi/types/IGetItemsResult';
import { IBackgroundJobStatistics } from '../serverApi/types/IBackgroundJobStatistics';

export interface IGetBackgroundJobStatisticsResult extends IGetItemsResult, IBackgroundJobStatistics {}

export class GetBackgroundJobStatisticsRequest extends Request<IGetItemsParams, IGetBackgroundJobStatisticsResult> {
  constructor(params: IGetItemsParams) {
    super('getBackgroundJobStatistics', params);
  }
}
